export default "__VITE_ASSET__jQXnEKyf__"